import PATHS from '../../routes/routes.const';
import { uuidRegex } from '../../utils/regexes';
import { RachelFocusedEntity, RachelPageEntity } from './rachelPageContext.types';

const HOME_ENTITY = 'home';
export const PRODUCT_COLOR_ENTITY = 'productColors';
const SETTINGS_SEGMENT = PATHS.main.settings.path.split('/').filter(Boolean)[0];

/**
 * Deriva a entidade da tela a partir do próprio pathname, sem lista de rotas:
 * toda rota de detalhe segue `/<entidade>/:id/...` ou `/settings/<entidade>/:id/...`,
 * então a entidade é o segmento anterior ao uuid. Sem uuid, é o primeiro segmento fora de settings.
 */
export const getRachelPageEntity = (pathname: string): RachelPageEntity => {
  const segments = pathname.split('/').filter(Boolean);
  const idIndex = segments.findIndex((segment) => uuidRegex.test(segment));

  if (idIndex > 0) {
    return { entity: segments[idIndex - 1], entityId: segments[idIndex] };
  }

  const entity =
    segments.find((segment) => segment !== SETTINGS_SEGMENT) ?? segments[0] ?? HOME_ENTITY;
  return { entity, entityId: null };
};

/**
 * O detalhe do produto abre em modal por cima da página e fica no hash `#product-details=<productColorId>`,
 * então ele não é a página: é um item aberto por cima dela. A entidade é `productColors` para o id não se
 * confundir com o productId que `products` carrega em `/settings/products/:id`. Kit usa outro hash
 * (`#kit-details`) e fica de fora: kitId não é um produto-cor.
 */
export const getRachelFocusedEntity = (productColorId?: string): RachelFocusedEntity => {
  if (productColorId && uuidRegex.test(productColorId)) {
    return { focusedEntity: PRODUCT_COLOR_ENTITY, focusedEntityId: productColorId };
  }

  return { focusedEntity: null, focusedEntityId: null };
};
